import { render, staticRenderFns } from "./3c_doc.vue?vue&type=template&id=415c63bd&scoped=true"
import script from "./3c_doc.vue?vue&type=script&lang=js"
export * from "./3c_doc.vue?vue&type=script&lang=js"
import style0 from "./3c_doc.vue?vue&type=style&index=0&id=415c63bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c63bd",
  null
  
)

export default component.exports